import { connect } from 'react-redux'
import ResetPasswordForm from '../components/landing-page/resetPasswordForm'

const mapStateToProps = state => ({...state.resetPasswordForm})

export default connect(mapStateToProps)(ResetPasswordForm)
